import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["onClick"]

import { ref, onMounted, toRefs, watch } from 'vue';
import EditGradesModal from '@/components/Grades/EditGradesModal.vue';
import { PERMISSIONS, GRADES_ORDER } from '@/enum';
import { can } from '@/composables';
import { PersonGrades } from '@/types/GradeInterface';
import { useGradeStore } from '@/store';

type FormattedGradesData = {
  organization_id: number;
  organization_name: string;
  grades: PersonGrades[];
};

type OrganizationInterface = {
  id: number;
  name: string;
  parent_id: number | null;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'Grades',
  props: {
    flattenOrganizations: {},
    userId: {}
  },
  setup(__props: any) {

const props = __props;
const gradesStore = useGradeStore();
const formatedGrades = ref<FormattedGradesData[]>([]);
const isModalOpen = ref(false);
const currentGrades = ref<PersonGrades[]>([]);
const currentOrganizationId = ref(0);
const currentOrganizationName = ref<string | null>(null);
const { flattenOrganizations, userId } = toRefs(props);

const init = async (): Promise<void> => {
  isModalOpen.value = false;
  gradesStore.personGrades = [];
  await gradesStore.fetchPersonGrades(userId.value);
  const allGrades = gradesStore.personGrades;
  const childOrgs = flattenOrganizations.value.filter(
    (obj, index, self) => index === self.findIndex((t) => t.id === obj.id),
  );

  const grouped = childOrgs.map((org) => {
    const orgGrades = allGrades.filter((grade) => grade.organization_id === org.id);
    if (orgGrades.length > 0) {
      orgGrades.sort((a, b) => {
        const indexA = GRADES_ORDER.findIndex((g) => g === a.grade);
        const indexB = GRADES_ORDER.findIndex((g) => g === b.grade);
        const safeIndexA = indexA === -1 ? GRADES_ORDER.length : indexA;
        const safeIndexB = indexB === -1 ? GRADES_ORDER.length : indexB;
        return safeIndexA - safeIndexB;
      });
    }
    return {
      organization_id: org.id,
      organization_name: org.name,
      grades: orgGrades,
    };
  });

  formatedGrades.value = grouped;
};

onMounted(() => {
  init();
});

watch(flattenOrganizations, () => {
  init();
});

watch(userId, () => {
  init();
});

const onEdit = (data: FormattedGradesData) => {
  currentGrades.value = data.grades;
  currentOrganizationId.value = data.organization_id;
  currentOrganizationName.value = data.organization_name;
  isModalOpen.value = true;
};

const closeModal = () => {
  isModalOpen.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_Column = _resolveComponent("Column")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Card, null, {
      header: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createElementVNode("h2", { class: "text-xl font-semibold" }, "Grades", -1)
      ]))]),
      content: _withCtx(() => [
        _createVNode(_component_DataTable, {
          value: formatedGrades.value,
          loading: _unref(gradesStore).loading,
          "data-key": "organization_id",
          "responsive-layout": "scroll",
          "sort-field": 'organization_name',
          "sort-order": 1
        }, {
          empty: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode("All Grades.", -1)
          ]))]),
          default: _withCtx(() => [
            (formatedGrades.value.length > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_Column, {
                    field: "organization_name",
                    header: "Organizations",
                    sortable: ""
                  }),
                  _createVNode(_component_Column, { header: "Grades" }, {
                    body: _withCtx(({ data }) => [
                      (data.grades.length > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(data.grades.map((g) => g.grade).join(', ')), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_2, "All grades"))
                    ]),
                    _: 1
                  }),
                  (_unref(can)([_unref(PERMISSIONS).GRADE_ASSIGN]))
                    ? (_openBlock(), _createBlock(_component_Column, {
                        key: 0,
                        field: "actions",
                        header: "Actions"
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("a", {
                            class: "flex items-center space-x-2",
                            onClick: ($event: any) => (onEdit(data))
                          }, [
                            _createVNode(_component_Icon, {
                              name: "edit",
                              class: "text-lg text-blue-500"
                            }),
                            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-sm text-gray-800" }, "Edit", -1))
                          ], 8, _hoisted_3)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["value", "loading"])
      ]),
      _: 1
    }),
    (_unref(can)([_unref(PERMISSIONS).GRADE_ASSIGN]) && currentGrades.value)
      ? (_openBlock(), _createBlock(EditGradesModal, {
          key: 0,
          visible: isModalOpen.value,
          "person-id": props.userId,
          "organization-id": currentOrganizationId.value,
          "organization-name": currentOrganizationName.value,
          "current-grades": currentGrades.value,
          onCancel: closeModal,
          onSync: init
        }, null, 8, ["visible", "person-id", "organization-id", "organization-name", "current-grades"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})